export default class UrlClipboardCopyService {
  constructor($document, $location, FlashService) {
    'ngInject';
    this.$document = $document[0];
    this.origin = $location.$$absUrl.split('#!/')[0];
    this.FlashService = FlashService;
  }
  
  renderRouteForTemplate(template) {
    return template?.type === 'dynamic' ? 'render-dynamic' : 'render-template';
  }

  originBase() {
    return String(this.origin || '').replace(/\/+$/, '');
  }

  buildHashRouteUrl(route, query) {
    return `${this.originBase()}/#!/${route}?${query}`;
  }

  getUrlLinkUrl(template, linkId) {
    const route = this.renderRouteForTemplate(template);
    const templateId = encodeURIComponent(String(template.id).trim());
    const submitLinkId = encodeURIComponent(btoa(String(linkId).trim()));
    return this.buildHashRouteUrl(route, `templateId=${templateId}&submitLinkId=${submitLinkId}`);
  }

  getAddUrl(template) {
    const route = this.renderRouteForTemplate(template);
    return this.buildHashRouteUrl(route, `templateId=${template.id}&action=submit`);
  }
  
  getPrintEditURL(template, action){
    // action = ( action === 'edit' ) ? 'update' : 'action';
    // What is this for?
    const refs = template.references.filter( ref => ref.templateId === template.id);
    
    return `"${this.origin}#!/render-template?" & 
      "templateId=${template.id}&" &
      "action=${action}&" &
      "rids=" & 
      "${this.encodeRIDs(refs)}"`;
  }

  encodeRIDs(refs){
    const rids = refs.reduce( (acc, cur) => {
      const pair = this.ridPair(cur);
      return `${acc}${acc?',':''}${pair}`;
    }, '');
    const ret = `%7b${rids.replace(/\] & "/g, '] & \n"')}%7D`;

    return ret;
  }

  ridPair(ref){
    return `%22${ref.id}%22:%22" & [ ${ref.name} ID ] & "%22`;
  }
  
  copyToClipboard(action, template) {
    
    const str = (action === 'add')
      ? this.getAddUrl(template)
      : this.getPrintEditURL(template, action);

    this.copy(str);
  }
  
  copy(str){
    const el = this.$document.createElement('textarea');
    el.value = str;
    this.$document.body.appendChild(el);
    el.select();
    this.$document.execCommand('copy');
    this.$document.body.removeChild(el);
    this.FlashService.success( 'Copied to clipboard:\n' + str );
  }

  copyImg(url, filename){
    const SelectText = (element) => {
      var doc = this.$document;
      if (doc.body.createTextRange) {
          var range = this.$document.body.createTextRange();
          range.moveToElementText(element);
          range.select();
      } else if (window.getSelection) {
          var selection = window.getSelection();
          var range = this.$document.createRange();
          range.selectNodeContents(element);
          selection.removeAllRanges();
          selection.addRange(range);
      }
    }

    var img = this.$document.createElement('img');
    img.src = url;
    img.alt = filename;

    var div = this.$document.createElement('div');
    div.contentEditable = true;
    div.appendChild(img);
    this.$document.body.appendChild(div);

    // do copy
    SelectText(div);
    this.$document.execCommand('Copy');
    this.$document.body.removeChild(div);
    this.FlashService.success( 'Copied to clipboard:\n' + filename );

  }

}
